import type { BeerflexSettings } from "@/app/services/generated/beerflexsettingsService";
import type { IntegrationMeta } from "@/components/pages/integrations/composables/types";
import messages from "@/plugins/i18n";
import { EnumIntegrationStatus } from "@/components/pages/integrations/types";
import { integrationsMenu } from "@/app/ui/navigation/integrationsMenu";
import img from "@/assets/images/app/integrations/beerflex.svg";
import {
  BeerflexOrderFilter,
  beerflexOrderService,
} from "@/app/services/generated/beerflexorderService";
import type { LocalDate } from "@js-joda/core";
import { fillFilterDates } from "@/store/modules/integrationErrorStore";
import type { Maybe } from "@/components/utils/typeHelpers";

export function beerflexIsActivated(settings: Maybe<BeerflexSettings>) {
  return !!(
    settings &&
    settings.ftpServerAddress &&
    settings.ftpUsername &&
    settings.calculated.ftpPasswordLength
  );
}
export function beerflexMeta(
  settings: Maybe<BeerflexSettings>
): IntegrationMeta {
  const activated = beerflexIsActivated(settings);
  return {
    name: messages.beerflex_title,
    description: messages.beerflex_description,
    integrationRoute: { name: integrationsMenu.beerflex },
    miniImg: img,
    img,
    url: messages.beerflex_url,
    guideUrl: messages.beerflex_guide,
    activated,
    status: activated
      ? EnumIntegrationStatus.active
      : EnumIntegrationStatus.inactive,
  };
}

export async function getBeerflexOrders(
  fromDate?: LocalDate,
  toDate?: LocalDate
) {
  return (
    await beerflexOrderService.getBeerflexOrdersByFilter(
      fillFilterDates(new BeerflexOrderFilter(), fromDate, toDate)
    )
  ).orders;
}
